import { useQuery } from '@apollo/client';
import { useCurrentAccount } from '@application/api';
import { graphql } from '@gql/gql';
import type {
  UpdateLitterModalCountLittersQuery,
  UpdateLitterModalCountLittersQueryVariables,
} from '@gql/graphql';

export const UPDATE_LITTER_MODAL_COUNT_LITTERS = graphql(`
  query UpdateLitterModalCountLitters($where: LitterWhereInput) {
    aggregateLitter(where: $where) {
      _count {
        _all
      }
    }
  }
`);

export const useCountLitters = () => {
  const { currentAccount, currentAccountLoggedIn, currentAccountType } = useCurrentAccount();

  const { data, error, loading } = useQuery<
    UpdateLitterModalCountLittersQuery,
    UpdateLitterModalCountLittersQueryVariables
  >(UPDATE_LITTER_MODAL_COUNT_LITTERS, {
    variables: {
      where: {
        breederId: { equals: currentAccount?.id },
        archived: { equals: false },
        born: { equals: true },
        adminValidated: { equals: true },
        OR: [{ malesLeftCount: { gt: 0 } }, { femalesLeftCount: { gt: 0 } }],
      },
    },
    skip: !currentAccountLoggedIn || currentAccountType !== 'breeder',
  });

  return {
    // eslint-disable-next-line no-underscore-dangle
    litterCount: data?.aggregateLitter?._count?._all ?? 0,
    littersError: error,
    littersLoading: loading,
  };
};
